import TripRequestContainer from './trip-request-container';

export default TripRequestContainer;
